/**
 * Gedeelde logica voor 10×15 cm productlabels (EAN/SKU-streepjescode).
 * De vendored bundle registreert zich op window.JsBarcode; webpack require()
 * levert daar niet altijd een callable functie op — daarom altijd via window.
 */
import '../vendor/JsBarcode.all.min.js';

function getJsBarcode() {
  if (typeof window !== 'undefined' && typeof window.JsBarcode === 'function') {
    return window.JsBarcode;
  }
  return null;
}

function clearSvgEl(svgEl) {
  if (!svgEl) return;
  if (typeof svgEl.replaceChildren === 'function') {
    svgEl.replaceChildren();
    return;
  }
  while (svgEl.firstChild) {
    svgEl.removeChild(svgEl.firstChild);
  }
}

/** Streepjescode: EAN-13/8 als het kan, anders CODE128 op SKU of ruwe cijfers. */
export function getBarcodeSpec(product) {
  if (!product) return null;
  const eanRaw = String(product.ean || '').trim();
  const digits = eanRaw.replace(/\D/g, '');
  const sku = String(product.sku || '').trim();
  if (digits.length === 13) return { value: digits, format: 'EAN13' };
  if (digits.length === 12) return { value: digits, format: 'EAN13' };
  if (digits.length === 8) return { value: digits, format: 'EAN8' };
  if (digits.length > 0) return { value: digits, format: 'CODE128' };
  if (sku) return { value: sku.replace(/[^\x20-\x7E]/g, '') || sku, format: 'CODE128' };
  return null;
}

/** Tekent barcode op het SVG-element. Retourneert false bij falen (geen throw). */
export function renderBarcodeOnSvg(svgEl, spec) {
  if (!svgEl || !spec) return false;
  const JsBarcode = getJsBarcode();
  if (!JsBarcode) {
    console.error('[productLabelPrint] JsBarcode niet beschikbaar op window');
    return false;
  }
  clearSvgEl(svgEl);
  const opts = {
    width: spec.format === 'EAN13' ? 1.65 : 2,
    height: 68,
    displayValue: true,
    fontSize: 14,
    margin: 8,
    background: '#ffffff',
    lineColor: '#000000',
  };
  try {
    JsBarcode(svgEl, spec.value, { ...opts, format: spec.format });
    return true;
  } catch (firstErr) {
    try {
      const safe = String(spec.value).replace(/[^\x20-\x7E]/g, '');
      JsBarcode(svgEl, safe || '0', { ...opts, format: 'CODE128', width: 2 });
      return true;
    } catch (secondErr) {
      console.error('[productLabelPrint] Barcode tekenen mislukt', firstErr, secondErr);
      return false;
    }
  }
}
